<template>
  <div class="m-0 dbozone-font bg-subway" :class="`${lang}-font`">
    <div class="container d-flex flex-column justify-content-center">
      <div class="d-flex flex-column nav-subway">
        <section class="d-flex p-2">
          <h5 class="font-weight-bold m-0 text-title" :class="`-${lang} -subway`">{{ $t('subway.name') }}</h5>
        </section>
      </div>
      <div class="d-flex p-2 mt-1" v-for="(text, index) in textList" :key="index">
        <div v-if="index === 1">
          <div v-if="lang === 'zh'" class="">
            <span class="m-0 text-sub" :class="`-${lang}`">
              {{ $t(`${text}`) }}
            </span>
          </div>
          <div v-else class="">
            <span class="m-0 text-sub" :class="`-${lang}`">{{ $t(text) }}</span>
          </div>
        </div>
        <div v-else>
          <span class="m-0 text-sub" :class="`-${lang}`">{{ $t(text) }}</span>
        </div>
      </div>

      <div class="d-flex flex-column nav-subway">
        <section class="d-flex p-2">
          <h5 class="font-weight-bold m-0 text-title" :class="`-${lang} -subway`">{{ $t('subway.wild.title') }}</h5>
        </section>
      </div>
      <div class="d-flex p-2 mt-1">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('subway.wild.desc1') }}</span>
      </div>
      <div class="d-flex p-2 mt-1">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('subway.wild.desc2') }}</span>
      </div>
      <div class="d-flex p-2 mt-1">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('subway.wild.desc3') }}</span>
      </div>

      <div class="d-flex flex-column nav-subway">
        <section class="d-flex p-2">
          <h5 class="font-weight-bold m-0 text-title" :class="`-${lang} -subway`">{{ $t('subway.multiplier-title') }}
          </h5>
        </section>
      </div>
      <div class="d-flex p-2 mt-1">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('subway.multiplier-text1') }}</span>
      </div>
      <div class="d-flex p-2 mt-1">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('subway.multiplier-text2') }}</span>
      </div>

      <div class="d-flex flex-column nav-subway">
        <section class="d-flex p-2">
          <h5 class="font-weight-bold m-0 text-title" :class="`-${lang} -subway`">{{ $t('subway.freespin-title') }}</h5>
        </section>
      </div>
      <div class="d-flex p-2 mt-1">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('subway.freespin-text1') }}</span>
      </div>
      <div class="d-flex p-2 mt-1">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('subway.freespin-text2') }}</span>
      </div>
      <div class="d-flex p-2 mt-1">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('subway.freespin-text3') }}</span>
      </div>

      <div class="d-flex flex-column nav-subway">
        <section class="d-flex p-2">
          <h5 class="font-weight-bold m-0 text-title" :class="`-${lang} -subway`">{{ $t('featurebuy.title') }}</h5>
        </section>
      </div>
      <div class="d-flex p-2 mt-1">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('featurebuy.text1') }}</span>
      </div>
      <div class="d-flex p-2 mt-1">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('featurebuy.text2') }}</span>
      </div>

      <div class="d-flex flex-column nav-subway">
        <section class="d-flex p-2">
          <h5 class="font-weight-bold m-0 text-title" :class="`-${lang} -subway`">{{ $t('main-game.title') }}</h5>
        </section>
      </div>
      <div class="d-flex p-2 mt-1 justify-content-center">
        <img class="mt-3 icon-info" :src="require(`../../assets/ruleGames/main/wallet_icon.png`)" alt="">
      </div>
      <div class="d-flex p-2 justify-content-center">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.wallet-balance') }}</span>
      </div>
      <div class="d-flex p-2">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.text-wallet') }}</span>
      </div>
      <div class="d-flex p-2 mt-1 justify-content-center">
        <img class="mt-3 icon-info" :src="require(`../../assets/ruleGames/subway/betamount_icon.png`)" alt="">
      </div>
      <div class="d-flex p-2 mt-1 justify-content-center">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.bet-amount') }}</span>
      </div>
      <div class="d-flex p-2">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.text-bet1') }}</span>
      </div>
      <div class="d-flex p-2 mt-1 justify-content-center">
        <img class="mt-3 icon-info" :src="require(`../../assets/ruleGames/subway/win_icon.png`)" alt="">
      </div>
      <div class="d-flex p-2 justify-content-center">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.win-amount') }}</span>
      </div>
      <div class="d-flex p-2">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.text-win-amount') }}</span>
      </div>
      <div class="d-flex p-2 mt-1 justify-content-center">
        <img class="mt-3 icon-info" :src="require(`../../assets/ruleGames/subway/spin_btn.png`)" alt="">
      </div>
      <div class="d-flex p-2 justify-content-center">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.spin') }}</span>
      </div>
      <div class="d-flex p-2">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.text-spin1') }}</span>
      </div>
      <div class="d-flex p-2">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.text-spin2') }}</span>
      </div>
      <div class="d-flex p-2">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.text-spin3') }}</span>
      </div>
      <div class="d-flex p-2">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.text-spin4') }}</span>
      </div>
      <div class="d-flex p-2 mt-1 justify-content-center">
        <img class="mt-3 icon-info" :src="require(`../../assets/ruleGames/subway/stop_btn.png`)" alt="">
      </div>
      <div class="d-flex p-2 justify-content-center">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.stop') }}</span>
      </div>
      <div class="d-flex p-2">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.text-stop') }}</span>
      </div>
      <div class="d-flex p-2 justify-content-center">
        <img class="mt-3 icon-info" :src="require(`../../assets/ruleGames/subway/btn_bet_size.png`)" alt="">
      </div>
      <div class="d-flex p-2">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.text-minus') }}</span>
      </div>
      <div class="d-flex p-2">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.text-plus') }}</span>
      </div>
      <div class="d-flex p-2 mt-1 justify-content-center">
        <img class="mt-3 icon-info" :src="require(`../../assets/ruleGames/subway/autospin_btn.png`)" alt="">
      </div>
      <div class="d-flex p-2 justify-content-center">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.autospin') }}</span>
      </div>
      <div class="d-flex p-2">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.text-auto1') }}</span>
      </div>
      <div class="d-flex p-2">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.text-auto2') }}</span>
      </div>
      <div class="d-flex p-2 mt-1 justify-content-center">
        <img class="mt-3 icon-info" :src="require(`../../assets/ruleGames/subway/menu_btn.png`)" alt="">
      </div>
      <div class="d-flex p-2 justify-content-center">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.menu') }}</span>
      </div>
      <div class="d-flex p-2">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.text-menu') }}</span>
      </div>
      <div class="d-flex p-2 mt-1 justify-content-center">
        <img class="mt-3 icon-info" :src="require(`../../assets/ruleGames/subway/quit_icon.png`)" alt="">
      </div>
      <div class="d-flex p-2 justify-content-center">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.quit') }}</span>
      </div>
      <div class="d-flex p-2">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.text-quit') }}</span>
      </div>
      <div class="d-flex p-2 justify-content-center">
        <img class="mt-3 icon-info" :src="require(`../../assets/ruleGames/subway/info_icon.png`)" alt="">
      </div>
      <div class="d-flex p-2 justify-content-center">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.pay-info') }}</span>
      </div>
      <div class="d-flex p-2">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.text-info') }}</span>
      </div>
      <div class="d-flex p-2 justify-content-center">
        <img class="mt-3 icon-info" :src="require(`../../assets/ruleGames/subway/paytable_icon.png`)" alt="">
      </div>
      <div class="d-flex p-2 justify-content-center">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.info-paytable') }}</span>
      </div>
      <div class="d-flex p-2">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.text-paytable') }}</span>
      </div>
      <div class="d-flex p-2 justify-content-center">
        <img class="mt-3 icon-info" :src="require(`../../assets/ruleGames/subway/history_icon.png`)" alt="">
      </div>
      <div class="d-flex p-2 justify-content-center">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.history') }}</span>
      </div>
      <div class="d-flex p-2">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.text-history') }}</span>
      </div>
      <div class="d-flex p-2 justify-content-center">
        <img class="mt-3 icon-info" :src="require(`../../assets/ruleGames/subway/option_icon.png`)" alt="">
      </div>
      <div class="d-flex p-2 justify-content-center">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.setting') }}</span>
      </div>
      <div class="d-flex p-2">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.text-setting') }}</span>
      </div>
      <div class="d-flex p-2 justify-content-center">
        <img class="mt-3 icon-info" :src="require(`../../assets/ruleGames/subway/close_icon.png`)" alt="">
      </div>
      <div class="d-flex p-2 justify-content-center">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.close') }}</span>
      </div>
      <div class="d-flex p-2">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.text-close') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'rule-subway',
  props: {
    data: Object,
    lang: String,
  },
  data() {
    return {
      textList: [
        'subway.text-rule1',
        'subway.text-rule2',
        '3_5_bonus_20.text-rule3',
        '3_5_bonus_20.text-rule4',
        '3_5_bonus_20.text-rule5',
        '3_5_bonus_20.text-rule6',
        '3_5_bonus_20.text-rule7',
        '3_5_bonus_20.text-rule8',
        '3_5_bonus_20.text-rule9',
        '3_5_bonus_20.text-rule10',
        '3_5_bonus_20.text-rule11',
        '3_5_bonus_20.text-rule12',
        '3_5_base.text-rule16',
        '3_5_base.text-rule17',
      ],
      baseBet: this.data.config.baseBet,
      betLevel: this.data.config.betLevel,
      betSize: this.data.config.betSize,
    }
  }
}
</script>

<style>
.bg-subway {
  background: #143767;
}

.nav-subway {
  background: #890CC9;
  border-radius: 10px;
}

.text-title.-subway {
  color: #fff;
}

.text-sub-gold {
  color: #FFCC2E;
  font-size: 5vw;
  text-align: left;
}
</style>